import { Card, CardContent, Grid } from "@material-ui/core";
import TiptapRichTextInputField from "../../../Components/TiptapRichTextInput";
import * as React from "react";
import { Edit, FormWithRedirect, TextInput, Toolbar, required } from "react-admin";
import { useVerifyPermission } from "@airborne/react-admin";

const MailManagementEdit = props => {
  useVerifyPermission("mailschemas", "edit");
  return (
    <Edit title={"Mail Schema Edit"} component="div" {...props}>
      <FormWithRedirect
        {...props}
        render={(formProps: any) => {
          return (
            <Card>
              <form>
                <CardContent>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={6} md={6} lg={4} />
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <TextInput source="subject" label="Subject" validate={required()} fullWidth multiline />
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <TiptapRichTextInputField source="body" validate={[required()]} />
                    </Grid>
                  </Grid>
                </CardContent>
                <Toolbar
                  {...props}
                  placeholder=""
                  record={formProps.record}
                  basePath={formProps.basePath}
                  undoable={true}
                  invalid={formProps.invalid}
                  handleSubmit={formProps.handleSubmit}
                  saving={formProps.saving}
                  resource="mailschemas"
                />
              </form>
            </Card>
          );
        }}
      />
    </Edit>
  );
};

export default MailManagementEdit;

const modules = {
  toolbar: [
    [{ header: "1" }, { header: "2" }, { font: [] }],
    [{ size: [] }],
    ["bold", "italic", "underline", "strike", "blockquote"],
    [{ list: "ordered" }, { list: "bullet" }, { indent: "-1" }, { indent: "+1" }],
    ["link", "image", "video"],
    ["clean"],
  ],
  clipboard: {
    // toggle to add extra line breaks when pasting HTML:
    matchVisual: false,
  },
};
const formats = [
  "header",
  "font",
  "size",
  "bold",
  "italic",
  "underline",
  "strike",
  "blockquote",
  "list",
  "bullet",
  "indent",
  "link",
  "image",
  "video",
];
